import { render, staticRenderFns } from "./NewReleaseChangelogs.vue?vue&type=template&id=2a34edd4"
import script from "./NewReleaseChangelogs.vue?vue&type=script&lang=js"
export * from "./NewReleaseChangelogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports